var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "logo",
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "80px",
      "height": "70px",
      "viewBox": "73.385 63.129 80 70"
    }
  }, [_c('path', {
    attrs: {
      "d": "M113.385,64.129l-40,20.138l40,20.138l40-20.138L113.385,64.129z M86.185,84.267l27.2-13.694l27.2,13.694\n  l-27.2,13.692L86.185,84.267z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "113.385,111.316 80.457,94.739 73.385,98.299 113.385,118.436 153.385,98.299 146.313,94.739 \t"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "113.385,125.009 80.457,108.432 73.385,111.993 113.385,132.129 153.385,111.993 146.313,108.432\n  "
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75e84cb4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/Logo.vue
// module id = 2060
// module chunks = 0